import React from 'react';

const SIZES = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12' };

export default function LoadingSpinner({ size = 'md', label = 'Loading…' }) {
  return (
    <div role="status" aria-live="polite" className="min-h-[200px] flex items-center justify-center">
      <div
        className={`${SIZES[size]} border-2 border-primary-500 border-t-transparent rounded-full animate-spin`}
        aria-label={label}
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
